import { CareProfileActionableFieldEnum, CareProfileActionableFieldValueEnum } from '@typing/Generated';

// eslint-disable-next-line @typescript-eslint/no-type-alias
type FieldCategoryMap = {
  [key in CareProfileActionableFieldEnum]: string;
};

const careProfileActionableFieldCategoryMap: FieldCategoryMap = {
  [CareProfileActionableFieldEnum.address]: 'careProfile',
  [CareProfileActionableFieldEnum.age]: 'initialConsultReport',
  [CareProfileActionableFieldEnum.bathroom_has_grab_bars]: 'safety',
  [CareProfileActionableFieldEnum.caregiver_types]: 'initialConsultReport',
  [CareProfileActionableFieldEnum.cognitive_statuses]: 'safety',
  [CareProfileActionableFieldEnum.concerns]: 'careProfile',
  [CareProfileActionableFieldEnum.considering_housing_change]: 'careProfile',
  [CareProfileActionableFieldEnum.country_code]: 'careProfile',
  [CareProfileActionableFieldEnum.current_care_transitions]: 'pme',
  [CareProfileActionableFieldEnum.dementia_severity]: 'initialConsultReport',
  [CareProfileActionableFieldEnum.emergency_plan_items]: 'safety',
  [CareProfileActionableFieldEnum.emotional_concerns]: 'initialConsultReport',
  [CareProfileActionableFieldEnum.fall_count]: 'safety',
  [CareProfileActionableFieldEnum.financial_manager]: 'initialConsultReport',
  [CareProfileActionableFieldEnum.guidance_type]: 'careProfile',
  [CareProfileActionableFieldEnum.health_insurance_types]: 'initialConsultReport',
  [CareProfileActionableFieldEnum.help_level_required]: 'pme',
  [CareProfileActionableFieldEnum.home_has_adequate_lighting]: 'safety',
  [CareProfileActionableFieldEnum.home_has_entry_level_facilities]: 'safety',
  [CareProfileActionableFieldEnum.home_has_smoke_detector]: 'safety',
  [CareProfileActionableFieldEnum.home_has_tripping_hazards]: 'safety',
  [CareProfileActionableFieldEnum.insurance_types]: 'initialConsultReport',
  [CareProfileActionableFieldEnum.legal_help_needed]: 'pme',
  [CareProfileActionableFieldEnum.marital_status]: 'initialConsultReport',
  [CareProfileActionableFieldEnum.medical_conditions]: 'pme',
  [CareProfileActionableFieldEnum.medication_assistance_needs]: 'careProfile',
  [CareProfileActionableFieldEnum.medications_affordable]: 'careProfile',
  [CareProfileActionableFieldEnum.name]: 'careProfile',
  [CareProfileActionableFieldEnum.notes]: 'careProfile',
  [CareProfileActionableFieldEnum.primary_care_provider_status]: 'careProfile',
  [CareProfileActionableFieldEnum.provider_finances_impacted]: 'pme',
  [CareProfileActionableFieldEnum.provider_financial_concerns]: 'pme',
  [CareProfileActionableFieldEnum.recent_hospitalization]: 'initialConsultReport',
  [CareProfileActionableFieldEnum.religion]: 'initialConsultReport',
  [CareProfileActionableFieldEnum.residence_type]: 'pme',
  [CareProfileActionableFieldEnum.sense_of_fulfillment]: 'pme',
  [CareProfileActionableFieldEnum.social_satisfaction]: 'pme',
  [CareProfileActionableFieldEnum.stability_supports]: 'safety',
  [CareProfileActionableFieldEnum.stage_meal_prep]: 'careProfile',
  [CareProfileActionableFieldEnum.stage_transportation]: 'careProfile',
  [CareProfileActionableFieldEnum.stairs_required_for_exit]: 'safety',
  [CareProfileActionableFieldEnum.urgency]: 'careProfile',
  [CareProfileActionableFieldEnum.va_connected]: 'initialConsultReport',
  [CareProfileActionableFieldEnum.veteran_connection]: 'initialConsultReport'
};

export const getCareProfileActionableFieldCategory = (field: CareProfileActionableFieldEnum) =>
  careProfileActionableFieldCategoryMap[field];

export const getCareProfileAnswerOptionsForActionableField: (
  field: CareProfileActionableFieldEnum
) => CareProfileActionableFieldValueEnum[] = (field: CareProfileActionableFieldEnum) => {
  if (field === CareProfileActionableFieldEnum.age) {
    return [
      CareProfileActionableFieldValueEnum.sixty_five_and_older,
      CareProfileActionableFieldValueEnum.eighteen_to_sixty_four,
      CareProfileActionableFieldValueEnum.under_eighteen,
      CareProfileActionableFieldValueEnum.deceased
    ];
  }
  if (field === CareProfileActionableFieldEnum.bathroom_has_grab_bars) {
    return [CareProfileActionableFieldValueEnum.yes, CareProfileActionableFieldValueEnum.no];
  }
  if (field === CareProfileActionableFieldEnum.caregiver_types) {
    return [
      CareProfileActionableFieldValueEnum.children,
      CareProfileActionableFieldValueEnum.spouse,
      CareProfileActionableFieldValueEnum.siblings,
      CareProfileActionableFieldValueEnum.friends,
      CareProfileActionableFieldValueEnum.caregivers,
      CareProfileActionableFieldValueEnum.neighbors,
      CareProfileActionableFieldValueEnum.other
    ];
  }
  if (field === CareProfileActionableFieldEnum.concerns) {
    return [
      CareProfileActionableFieldValueEnum.financial,
      CareProfileActionableFieldValueEnum.functional,
      CareProfileActionableFieldValueEnum.legal,
      CareProfileActionableFieldValueEnum.medical,
      CareProfileActionableFieldValueEnum.social
    ];
  }
  if (field === CareProfileActionableFieldEnum.cognitive_statuses) {
    return [
      CareProfileActionableFieldValueEnum.forgetful,
      CareProfileActionableFieldValueEnum.long_term_memory_loss,
      CareProfileActionableFieldValueEnum.none,
      CareProfileActionableFieldValueEnum.short_term_memory_loss
    ];
  }
  if (field === CareProfileActionableFieldEnum.considering_housing_change) {
    return [CareProfileActionableFieldValueEnum.yes, CareProfileActionableFieldValueEnum.no];
  }
  if (field === CareProfileActionableFieldEnum.current_care_transitions) {
    return [
      CareProfileActionableFieldValueEnum.adding_part_time_care,
      CareProfileActionableFieldValueEnum.adding_full_time_care,
      CareProfileActionableFieldValueEnum.reducing_care,
      CareProfileActionableFieldValueEnum.moving,
      CareProfileActionableFieldValueEnum.transferring,
      CareProfileActionableFieldValueEnum.going_home,
      CareProfileActionableFieldValueEnum.none,
      CareProfileActionableFieldValueEnum.other
    ];
  }
  if (field === CareProfileActionableFieldEnum.dementia_severity) {
    return [
      CareProfileActionableFieldValueEnum.mild,
      CareProfileActionableFieldValueEnum.moderate,
      CareProfileActionableFieldValueEnum.severe
    ];
  }
  if (field === CareProfileActionableFieldEnum.emergency_plan_items) {
    return [
      CareProfileActionableFieldValueEnum.able_to_call_911,
      CareProfileActionableFieldValueEnum.able_to_exit_home,
      CareProfileActionableFieldValueEnum.cell_phone,
      CareProfileActionableFieldValueEnum.response_button,
      CareProfileActionableFieldValueEnum.none
    ];
  }
  if (field === CareProfileActionableFieldEnum.emotional_concerns) {
    return [
      CareProfileActionableFieldValueEnum.depression,
      CareProfileActionableFieldValueEnum.anxiety,
      CareProfileActionableFieldValueEnum.isolation,
      CareProfileActionableFieldValueEnum.weight_changes,
      CareProfileActionableFieldValueEnum.sleep_problems,
      CareProfileActionableFieldValueEnum.other,
      CareProfileActionableFieldValueEnum.none
    ];
  }
  if (field === CareProfileActionableFieldEnum.fall_count) {
    return [CareProfileActionableFieldValueEnum.two_or_fewer, CareProfileActionableFieldValueEnum.three_or_more];
  }
  if (field === CareProfileActionableFieldEnum.financial_manager) {
    return [
      CareProfileActionableFieldValueEnum.loved_one,
      CareProfileActionableFieldValueEnum.other,
      CareProfileActionableFieldValueEnum.fiduciary,
      CareProfileActionableFieldValueEnum.unsure
    ];
  }
  if (field === CareProfileActionableFieldEnum.guidance_type) {
    return [CareProfileActionableFieldValueEnum.EXPERT_GUIDED, CareProfileActionableFieldValueEnum.SELF_GUIDED];
  }
  if (field === CareProfileActionableFieldEnum.health_insurance_types) {
    return [
      CareProfileActionableFieldValueEnum.medicare,
      CareProfileActionableFieldValueEnum.supplemental,
      CareProfileActionableFieldValueEnum.medicaid,
      CareProfileActionableFieldValueEnum.private,
      CareProfileActionableFieldValueEnum.veteran,
      CareProfileActionableFieldValueEnum.other,
      CareProfileActionableFieldValueEnum.none
    ];
  }
  if (field === CareProfileActionableFieldEnum.help_level_required) {
    return [
      CareProfileActionableFieldValueEnum.none,
      CareProfileActionableFieldValueEnum.basic_support,
      CareProfileActionableFieldValueEnum.constant_care,
      CareProfileActionableFieldValueEnum.crisis,
      CareProfileActionableFieldValueEnum.end_of_life,
      CareProfileActionableFieldValueEnum.deceased
    ];
  }
  if (field === CareProfileActionableFieldEnum.home_has_adequate_lighting) {
    return [CareProfileActionableFieldValueEnum.yes, CareProfileActionableFieldValueEnum.no];
  }
  if (field === CareProfileActionableFieldEnum.home_has_entry_level_facilities) {
    return [CareProfileActionableFieldValueEnum.yes, CareProfileActionableFieldValueEnum.no];
  }
  if (field === CareProfileActionableFieldEnum.home_has_smoke_detector) {
    return [CareProfileActionableFieldValueEnum.yes, CareProfileActionableFieldValueEnum.no];
  }
  if (field === CareProfileActionableFieldEnum.home_has_tripping_hazards) {
    return [CareProfileActionableFieldValueEnum.yes, CareProfileActionableFieldValueEnum.no];
  }
  if (field === CareProfileActionableFieldEnum.insurance_types) {
    return [
      CareProfileActionableFieldValueEnum.life_insurance,
      CareProfileActionableFieldValueEnum.long_term_care_insurance,
      CareProfileActionableFieldValueEnum.other,
      CareProfileActionableFieldValueEnum.none
    ];
  }
  if (field === CareProfileActionableFieldEnum.legal_help_needed) {
    return [CareProfileActionableFieldValueEnum.yes, CareProfileActionableFieldValueEnum.no];
  }
  if (field === CareProfileActionableFieldEnum.marital_status) {
    return [
      CareProfileActionableFieldValueEnum.single,
      CareProfileActionableFieldValueEnum.married,
      CareProfileActionableFieldValueEnum.domestic_partner,
      CareProfileActionableFieldValueEnum.divorced,
      CareProfileActionableFieldValueEnum.separated,
      CareProfileActionableFieldValueEnum.widowed,
      CareProfileActionableFieldValueEnum.other
    ];
  }
  if (field === CareProfileActionableFieldEnum.medical_conditions) {
    return [
      CareProfileActionableFieldValueEnum.heart_condition,
      CareProfileActionableFieldValueEnum.cancer,
      CareProfileActionableFieldValueEnum.lung_condition,
      CareProfileActionableFieldValueEnum.stroke,
      CareProfileActionableFieldValueEnum.diabetes,
      CareProfileActionableFieldValueEnum.dementia,
      CareProfileActionableFieldValueEnum.kidney_condition,
      CareProfileActionableFieldValueEnum.hearing_or_vision_loss,
      CareProfileActionableFieldValueEnum.mental_health,
      CareProfileActionableFieldValueEnum.im_not_sure,
      CareProfileActionableFieldValueEnum.none,
      CareProfileActionableFieldValueEnum.other
    ];
  }
  if (field === CareProfileActionableFieldEnum.medication_assistance_needs) {
    return [
      CareProfileActionableFieldValueEnum.i_dont_know,
      CareProfileActionableFieldValueEnum.no,
      CareProfileActionableFieldValueEnum.organizing_and_dispensing,
      CareProfileActionableFieldValueEnum.refilling
    ];
  }
  if (field === CareProfileActionableFieldEnum.medications_affordable) {
    return [
      CareProfileActionableFieldValueEnum.i_dont_know,
      CareProfileActionableFieldValueEnum.no,
      CareProfileActionableFieldValueEnum.yes
    ];
  }
  if (field === CareProfileActionableFieldEnum.provider_finances_impacted) {
    return [CareProfileActionableFieldValueEnum.yes, CareProfileActionableFieldValueEnum.no];
  }
  if (field === CareProfileActionableFieldEnum.provider_financial_concerns) {
    return [
      CareProfileActionableFieldValueEnum.qualifying_for_financial_programs,
      CareProfileActionableFieldValueEnum.paying_for_care,
      CareProfileActionableFieldValueEnum.planning_for_future,
      CareProfileActionableFieldValueEnum.managing_finances,
      CareProfileActionableFieldValueEnum.other,
      CareProfileActionableFieldValueEnum.no
    ];
  }
  if (field === CareProfileActionableFieldEnum.primary_care_provider_status) {
    return [
      CareProfileActionableFieldValueEnum.has_but_no_past_year_appointment,
      CareProfileActionableFieldValueEnum.has_with_past_year_appointment,
      CareProfileActionableFieldValueEnum.i_dont_know,
      CareProfileActionableFieldValueEnum.no
    ];
  }
  if (field === CareProfileActionableFieldEnum.recent_hospitalization) {
    return [CareProfileActionableFieldValueEnum.yes, CareProfileActionableFieldValueEnum.no];
  }
  if (field === CareProfileActionableFieldEnum.religion) {
    return [
      CareProfileActionableFieldValueEnum.none,
      CareProfileActionableFieldValueEnum.atheism,
      CareProfileActionableFieldValueEnum.bahai,
      CareProfileActionableFieldValueEnum.buddhism,
      CareProfileActionableFieldValueEnum.catholicism,
      CareProfileActionableFieldValueEnum.christianity,
      CareProfileActionableFieldValueEnum.hinduism,
      CareProfileActionableFieldValueEnum.islam,
      CareProfileActionableFieldValueEnum.jainism,
      CareProfileActionableFieldValueEnum.jehovahs_witness,
      CareProfileActionableFieldValueEnum.judaism,
      CareProfileActionableFieldValueEnum.mormonism,
      CareProfileActionableFieldValueEnum.other,
      CareProfileActionableFieldValueEnum.paganism,
      CareProfileActionableFieldValueEnum.rastafari,
      CareProfileActionableFieldValueEnum.santeria,
      CareProfileActionableFieldValueEnum.shinto,
      CareProfileActionableFieldValueEnum.sikhism,
      CareProfileActionableFieldValueEnum.spiritualism,
      CareProfileActionableFieldValueEnum.taoism,
      CareProfileActionableFieldValueEnum.unitarianism,
      CareProfileActionableFieldValueEnum.zoroastrianism
    ];
  }
  if (field === CareProfileActionableFieldEnum.residence_type) {
    return [
      CareProfileActionableFieldValueEnum.home_alone,
      CareProfileActionableFieldValueEnum.home_with_others,
      CareProfileActionableFieldValueEnum.assisted_living_community,
      CareProfileActionableFieldValueEnum.memory_care_community,
      CareProfileActionableFieldValueEnum.skilled_nursing_facility,
      CareProfileActionableFieldValueEnum.other
    ];
  }
  if (field === CareProfileActionableFieldEnum.sense_of_fulfillment) {
    return [
      CareProfileActionableFieldValueEnum.not_at_all,
      CareProfileActionableFieldValueEnum.level_2,
      CareProfileActionableFieldValueEnum.neutral,
      CareProfileActionableFieldValueEnum.level_4,
      CareProfileActionableFieldValueEnum.extremely
    ];
  }
  if (field === CareProfileActionableFieldEnum.social_satisfaction) {
    return [
      CareProfileActionableFieldValueEnum.not_at_all,
      CareProfileActionableFieldValueEnum.level_2,
      CareProfileActionableFieldValueEnum.neutral,
      CareProfileActionableFieldValueEnum.level_4,
      CareProfileActionableFieldValueEnum.extremely
    ];
  }
  if (field === CareProfileActionableFieldEnum.stability_supports) {
    return [
      CareProfileActionableFieldValueEnum.cane_or_walker,
      CareProfileActionableFieldValueEnum.objects,
      CareProfileActionableFieldValueEnum.wheelchair,
      CareProfileActionableFieldValueEnum.none
    ];
  }
  if (field === CareProfileActionableFieldEnum.stage_meal_prep) {
    return [
      CareProfileActionableFieldValueEnum.dependent,
      CareProfileActionableFieldValueEnum.interdependent,
      CareProfileActionableFieldValueEnum.independent
    ];
  }
  if (field === CareProfileActionableFieldEnum.stage_transportation) {
    return [
      CareProfileActionableFieldValueEnum.dependent,
      CareProfileActionableFieldValueEnum.interdependent,
      CareProfileActionableFieldValueEnum.independent
    ];
  }
  if (field === CareProfileActionableFieldEnum.stairs_required_for_exit) {
    return [CareProfileActionableFieldValueEnum.yes, CareProfileActionableFieldValueEnum.no];
  }
  if (field === CareProfileActionableFieldEnum.urgency) {
    return [
      CareProfileActionableFieldValueEnum.asap,
      CareProfileActionableFieldValueEnum.just_browsing,
      CareProfileActionableFieldValueEnum.soon
    ];
  }
  if (field === CareProfileActionableFieldEnum.va_connected) {
    return [CareProfileActionableFieldValueEnum.yes, CareProfileActionableFieldValueEnum.no];
  }
  if (field === CareProfileActionableFieldEnum.veteran_connection) {
    return [
      CareProfileActionableFieldValueEnum.self,
      CareProfileActionableFieldValueEnum.spouse,
      CareProfileActionableFieldValueEnum.neither
    ];
  }
  return [];
};
